<!-- 添加商品组件-->
<template>
<div>
  <!--面包屑导航区域-->
  <el-breadcrumb separator-class="el-icon-arrow-right" class="bread">
    <el-breadcrumb-item>首页</el-breadcrumb-item>
    <el-breadcrumb-item>商品管理</el-breadcrumb-item>
    <el-breadcrumb-item>添加商品</el-breadcrumb-item>
  </el-breadcrumb>
  <!--添加商品表单-->
  <el-form label-width="100px" :model="form" :ref="form">
      <el-form-item label="店铺名称">
        <el-select v-model="shopId" placeholder="请选择店铺">
          <el-option v-for="item in shopNameList" :key="item.id" :label="item.shopName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品名称">
        <el-input placeholder="请输入商品名称" v-model="form.name" style="width: 222px"></el-input>
      </el-form-item>
      <el-form-item label="商品副标题">
        <el-input placeholder="请输入商品副标题" v-model="form.subtitle" style="width: 222px"></el-input>
      </el-form-item>
    <!--http://111.229.140.47:8803/business/uploadPic-->
    <!--"https://122.51.112.224:8443/product/business/uploadPic"-->
      <el-form-item label="商品图片">
        <el-upload
          ref="imgUpload"
          action="https://www.njzhny.com:8443/product/business/uploadPic"
          list-type="picture-card"
          :headers="headers"
          :on-success="uploadSuccess"
          :on-remove="handleRemove">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="商品普通价格">
        <el-input placeholder="请输入商品普通价格" @keyup.native="proving(index)"  v-model="form.normalPrice"  style="width: 222px" ></el-input>
      </el-form-item>
      <el-form-item label="商品促销价格">
        <el-input placeholder="请输入商品促销价格" v-model="form.promotionPrice" style="width: 222px" ></el-input>
      </el-form-item>
      <el-form-item label="库存数量">
        <el-input placeholder="请输入库存数量" v-model="form.stock" style="width: 222px" ></el-input>
      </el-form-item>
      <el-form-item label="商品状态">
        <el-select v-model="form.status" placeholder="请商品状态">
          <el-option label="未上架" value=0></el-option>
          <el-option label="上架" value=1></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品详情">
        <el-input type="textarea" v-model="form.detail" style="width: 250px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" style="margin-left: 50px">添加商品</el-button>
        <!--<el-button @click="cancel">取消</el-button>-->
      </el-form-item>
    </el-form>
</div>
</template>

<script>
import request from '../../http/categories'

export default {
  name: 'AddCategories',
  data () {
    return {
      form: { // 表单数据
        /* shopId: '', // 店铺名称 */
        name: '', // 商品名称
        normalPrice: '', // 商品普通价格
        promotionPrice: '', // 商品促销价格
        stock: '', // 库存数量
        detail: '', // 商品详情
        status: '', // 商品状态
        subtitle: '' // 商品副标题
      },
      shopNameList: [], // 店铺名数组
      shopId: '', // 店铺名对应id
      fileList: [], /* 存放图片 */
      /* mytoken: window.sessionStorage.getItem('token'), */
      headers: {
        Authorization: window.sessionStorage.getItem('token')
      }
    }
  },
  methods: {
    // 图片上传成功时触发
    uploadSuccess (res, file, fileList) {
      this.fileList = file
      // console.log(this.fileList)
    },
    // 图片删除
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    async onSubmit () { // 点击提交按钮时增加商品
      const sendData = {
        categoryId: 1, // 商品分类id
        mainImage: this.fileList.response.data, // 商品图片
        detail: this.form.detail, // 商品详情
        name: this.form.name, // 商品名称
        normalPrice: this.form.normalPrice, // 商品普通价格
        priority: 1, // 优先级
        promotionPrice: this.form.promotionPrice, // 商品促销价格
        sales: 0, // 商品销量(默认是0) */
        shopId: this.shopId, // 店铺名称
        status: this.form.status, // 商品状态（0：未上架， 1： 上架）
        stock: this.form.stock, // 库存数量
        subtitle: this.form.subtitle // 商品副标题
      }
      // console.log(sendData)
      const res = await request.addCategories(sendData)
      // console.log(res)
      if (res.data.message === '新增商品成功') {
        this.$message({
          message: '恭喜你，添加商品成功',
          type: 'success'
        })
        location.reload(1000)
      }
    },
    async getShopIdList () { // 获取店铺列表
      const getShopNameData = {
        pageNum: 1,
        pageSize: 50,
        userName: window.sessionStorage.getItem('username')
      }
      const res = await request.getShopNameList(getShopNameData)
      this.shopNameList = res.data.data.content
    }
  },
  // 只能输入数字且只有一位小数
    proving (e) {
  // eslint-disable-next-line no-irregular-whitespace
　　　 // this.form.skus[e].Price 是input的值
      // 先把非数字的都替换掉，除了数字和.
      this.form.skus[e].Price = this.form.skus[e].Price.replace(/[^\d.]/g, '')
      // 必须保证第一个为数字而不是.
      this.form.skus[e].Price = this.form.skus[e].Price.replace(/^\./g, '')
      // 保证只有出现一个.而没有多个.
      this.form.skus[e].Price = this.form.skus[e].Price.replace(/\.{2,}/g, '')
      // 保证.只出现一次，而不能出现两次以上
      this.form.skus[e].Price = this.form.skus[e].Price.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
      let index = -1
      for (let i in this.form.skus[e].Price) {
          if (this.form.skus[e].Price[i] === '.') {
              index = i
          }
          if (index !== -1) {
              if (i - index > 1) {
                  this.form.skus[e].Price = this.form.skus[e].Price.substring(0, this.form.skus[e].Price.length - 1)
              }
          }
      }
  },
  created () {
    this.getShopIdList() // jy 组件创建获取店铺名列表
  }
}
</script>

<style scoped>
.bread{
  margin-bottom: 20px;
}
/*上传图片样式设置*/
/*.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}*/
</style>
